Object.keys||(Object.keys=function(e){if(e!==Object(e))throw new TypeError("Object.keys called on a non-object");var t,r=[];for(t in e)Object.prototype.hasOwnProperty.call(e,t)&&r.push(t);return r});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dingtalk-jsapi/lib/polyfills/objectKeys.js
// module id = zMUv
// module chunks = 0